import { useEffect, useState } from "react";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { OpenStorageService } from "./core/_request";
import { HttpStatusCode } from "axios";
import {
  useOpenStorageListState,
  useOpenStorageStore,
} from "./store/OpenStorageStore";
import { Loader } from "../../../common/components/Loader/Loader";
import OpenStorageForm from "./OpenStorageForm";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const OpenStorageList = () => {
  const {
    setOpenStorageList,
    openStorageList,
    actioned,
    totalItems,
    setActioned,
  } = useOpenStorageStore();
  const { pageState, setPageState, resetPageState } = useOpenStorageListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "code",
      title: "Code",
      dataIndex: "code",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "capacity",
      title: "Capacité",
      dataIndex: "capacity",
      show: true,
      isCanSort: true,
      // searchType: "text"
    },
  ];

  useEffect(() => {
    fetchAllOpenStorage(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await OpenStorageService.getOpenStorage(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await OpenStorageService.deleteOpenStorage(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllOpenStorage();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllOpenStorage = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await OpenStorageService.getOpenStorageList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setOpenStorageList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Terres pleins"
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={openStorageList}
            params={pageState}
            onAction={onActionClick}
            isCanDelete={() => true}
            isCanEdit={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            onChangePage={handleSetParams}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <OpenStorageForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default OpenStorageList;
